import { render, staticRenderFns } from "./LikesGiven.vue?vue&type=template&id=2a69d96c&"
import script from "./LikesGiven.vue?vue&type=script&lang=js&"
export * from "./LikesGiven.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports